import { Container, Box, useMediaQuery } from '@mui/material'
import React, { ReactNode } from 'react'
import {theme} from '../../theme/DashboardTheme'

interface PageLayoutProps {
  children: ReactNode
}

const PageLayout = ({ children}: PageLayoutProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Container
      sx={{
        maxWidth: {xs: '100%', sm: 455, md:1000, lg: 1350, xl: 1450},
        mb: isMobile? 4:0,
        px: { xs: 4, sm: 4 },
        pt: isMobile? 2:5,
        pb: isMobile? 2:0,
        mx: {md:1, lg: 'auto', xl: 3},
      }}>
      <Box>{children}</Box>
    </Container>
  )
}

export default PageLayout
